import React from "react";
import { BookOpen } from "lucide-react";
import CustomerSupportChatbot from "../components/Chatbot";
import DatabaseSelector, { DatabaseProvider } from "../components/DatabaseSelector";

interface HomeProps {
  navbarValues: {
    apiKey: string;
    selectedOption: string;
  };
}

const Home: React.FC<HomeProps> = ({ navbarValues }) => {
  // console.log("vanakam,,,,,,,,,",navbarValues.selectedOption,navbarValues.apiKey);
  return (
    <DatabaseProvider>
      <>
      <div className="flex items-center gap-3 mb-6 bg-white p-4 border-b border-gray-200">
        <h1 className="text-[20px] font-bold">Welcome</h1>
      </div>
      <div className="p-8">
        <div className="flex items-center gap-3 mb-6">
         
        </div>
        <div className="space-y-6">
          <DatabaseSelector />
          <CustomerSupportChatbot
            apiKey={navbarValues.apiKey} // Use API Key from Navbar
            selectedOption={navbarValues.selectedOption} 
          // Use selected option from Navbar
          />
        </div>
      </div>
      </>
    </DatabaseProvider>
  );
};

export default Home;
